import React, { useRef } from "react"
import { ISIContent } from "./IsiContent"
import tw from "twin.macro"
import Container from "@structure/Container"

const Isi = ({ location }) => {
  const isiStaticRef = useRef(null)

  const isHome = location?.pathname === "/"

  return (
    <div
      tabIndex={-1}
      id="main-isi"
      tw="pb-6 pt-4 lg:(mt-12 pb-12 pt-0)"
      css={[
        isHome &&
          tw`smallHScreen:(pt-32) bg-white !transform-none pr-8 pt-36 md:(pt-8) lg:(pt-12 pr-0 mt-0)`,
      ]}
      ref={isiStaticRef}
    >
      <Container>
        <div tw="mr-[32px] lg:(mr-0)">
          <ISIContent />
        </div>
      </Container>
    </div>
  )
}

export default Isi
